import { render, staticRenderFns } from "./ShowProStats.vue?vue&type=template&id=6f664f94"
import script from "./ShowProStats.vue?vue&type=script&lang=js"
export * from "./ShowProStats.vue?vue&type=script&lang=js"
import style0 from "./ShowProStats.vue?vue&type=style&index=0&id=6f664f94&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports